import React, { Component } from "react";
import FirstPage from "./FirstPage";
import { Success } from "./Success";

import "url-search-params-polyfill";

import "../styles/main.css";

import { parsePhoneNumberFromString as format } from "libphonenumber-js";

let search = window.location.search;
let params = new URLSearchParams(search);
let successParam = params.get("success");
let codeCoupon = params.get("code");

export class Hot extends Component {
  state = {
    step: successParam ? 1 : 0,
    fullName: "",
    phoneNumber: "",
    validPhoneNumber: "",
    success: successParam,
    classValues: [
      "א׳",
      "ב׳",
      "ג׳",
      "ד׳",
      "ה׳",
      "ו׳",
      "ז׳",
      "ח׳",
      "ט׳",
      "י׳",
      "יא׳",
      "יב׳"
    ],
    classSubValues: [],
    classSelection: "",
    classSubSelection: "",
    invalidPhone: false,
    hotCode: codeCoupon || "",
    couponCodeStatus: "false",
    openMessageModal: false
  };

  // Go back to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1
    });
  };

  /***** Jsl application ******/

  // First page FULL NAME
  handleChangeName = async e => {
    await this.setState({ fullName: e.target.value });
  };

  // First page PHONE NUMBER
  handleChangePhoneNumber = async e => {
    const userPhoneInput = e.target.value;
    await this.setState({
      phoneNumber: userPhoneInput
    });

    const formattedPhone = format(userPhoneInput, "IL");
    if (formattedPhone) {
      if (formattedPhone.isValid()) {
        await this.setState({
          validPhoneNumber: formattedPhone.number,
          invalidPhone: false
        });
      } else {
        await this.setState({
          invalidPhone: true
        });
      }
    } else {
      await this.setState({
        invalidPhone: true
      });
    }
  };

  // Class select dropdown
  handleChangeClassValues = async e => {
    await this.setState({
      classSelection: e.target.value
    });

    await this.setSubListValues(this.state.classSelection);
  };

  // sets the sublist values
  setSubListValues = async value => {
    let subListDropdown;
    switch (value) {
      case "א׳":
      case "ב׳":
      case "ג׳":
      case "ד׳":
      case "ה׳":
      case "ו׳":
      case "ז׳":
      case "ח׳":
      case "ט׳":
        subListDropdown = [];
        break;
      case "י׳":
        subListDropdown = ['3 יח"ל', '4 יח"ל', '5 יח"ל'];
        break;
      case "יא׳":
      case "יב׳":
        subListDropdown = [
          "3 יחידות שאלון 182 (801)",
          "3 יחידות שאלון 381 (802)",
          "3 יחידות שאלון 382 (803)",
          "4 יחידות שאלון 481 (804)",
          "4 יחידות שאלון 482 (805)",
          "5 יחידות שאלון 581 (806)",
          "5 יחידות שאלון 582 (807)"
        ];
        break;
      default:
        break;
    }
    await this.setState({
      classSubValues: subListDropdown
    });
  };

  // class sublist second dropdown
  handleChangeSubClassValues = async e => {
    await this.setState({
      classSubSelection: e.target.value
    });
  };

  handleChangeHotCode = e => {
    this.setState({
      hotCode: e.target.value
    });
  };
  /***** End Jsl application ******/

  // finish step where all data is sent to an API
  finish = async () => {
    let allValues;
    // To retrive that item
    try {
      console.log("1");
      const serializedState = localStorage.getItem("state");
      console.log("2");

      if (serializedState === null) {
        console.log("3");
        return undefined;
      }
      allValues = JSON.parse(serializedState);
    } catch (err) {
      console.log("4");
      allValues = undefined;
    }
    console.log("5");
    const {
      fullName,
      validPhoneNumber,
      classSelection,
      classSubSelection,
      hotCode
    } = allValues;
    //send request to API with all the values in an object
    const Http = new XMLHttpRequest();
    const url = `https://script.google.com/a/class.me/macros/s/AKfycbzueNu2PiBFT2I_nIMet5fSBeRLNpN5YrFHjwQGV_7Z_llOGo4/exec?fullName=${fullName}&userMobile=${validPhoneNumber}&grade=${classSelection}&gradeLevel=${classSubSelection}&hotCode=${hotCode}`;
    Http.open("GET", url);

    Http.onreadystatechange = e => {
      if (Http.readyState !== 4) return;
      console.log(Http.responseText);
    };

    Http.send();
  };

  cancel = () => {
    this.setState({
      step: 0,
      fullName: "",
      validPhoneNumber: "",
      classSelection: "",
      classSubSelection: "",
      hotCode: ""
    });
  };

  saveToLocalStorage = () => {
    const {
      fullName,
      validPhoneNumber,
      classSelection,
      classSubSelection,
      hotCode
    } = this.state;
    const allValues = {
      fullName,
      validPhoneNumber,
      classSelection,
      classSubSelection,
      hotCode
    };
    // To save the item
    try {
      const serializedState = JSON.stringify(allValues);
      localStorage.setItem("state", serializedState);
    } catch (err) {
      return undefined;
    }
  };

  // check if code is valid
  checkCouponCode = async () => {
    const url = `https://script.google.com/macros/s/AKfycbzquc6-qzVaFiQZKwSh9Tpt2z1pHZuVXIfesTbMwp9OpSjsd0U/exec?code=${this.state.hotCode}`;

    //send request to API with all the values in an object
    const Http = new XMLHttpRequest();
    Http.open("GET", url, true);

    Http.onreadystatechange = async e => {
      if (Http.readyState !== 4) return;
      console.log(Http);
      let response = Http.responseText;
      switch (response) {
        case "true":
          console.log("response is true");
          await this.setState({
            couponCodeStatus: "true",
            openMessageModal: false,
            step: 1
          });

          console.log("Saving to local storage");
          await this.saveToLocalStorage();
          console.log("Sennding api request");
          await this.finish();

          break;
        case "false":
          console.log("response is ", response);
          await this.setState({
            couponCodeStatus: "false",
            openMessageModal: true,
            step: 0
          });
          break;
        case "used":
          console.log("response is ", response);
          await this.setState({
            couponCodeStatus: "used",
            openMessageModal: true,
            step: 0
          });
          break;
        default:
          break;
      }
    };

    Http.send();
  };

  handleModalClose = () => {
    this.setState({
      openMessageModal: false
    });
  };

  render() {
    const { step } = this.state;
    const {
      fullName,
      phoneNumber,
      validPhoneNumber,
      classSelection,
      classSubSelection,
      hotCode
    } = this.state;
    const values = {
      fullName,
      phoneNumber,
      validPhoneNumber,
      classSelection,
      classSubSelection,
      hotCode
    };

    let mainContent = null;

    switch (step) {
      case 0:
        mainContent = (
          <FirstPage
            nextStep={this.nextStep}
            handleChangeName={this.handleChangeName}
            handleChangePhoneNumber={this.handleChangePhoneNumber}
            classValues={this.state.classValues}
            handleChangeClassValues={this.handleChangeClassValues}
            classSubValues={this.state.classSubValues}
            handleChangeSubClassValues={this.handleChangeSubClassValues}
            handleChangeHotCode={this.handleChangeHotCode}
            values={values}
            cancel={this.cancel}
            currStep={this.state.step}
            validPhoneNumber={this.state.validPhoneNumber}
            invalidPhone={this.state.invalidPhone}
            saveToLocalStorage={this.saveToLocalStorage}
            finish={this.finish}
            couponCodeStatus={this.state.couponCodeStatus}
            checkCouponCode={this.checkCouponCode}
            openMessageModal={this.state.openMessageModal}
            handleModalClose={this.handleModalClose}
          />
        );
        break;

      case 1:
        mainContent = <Success finish={this.finish} />;
        break;

      default:
        console.log("Invalid step", step);
        break;
    }
    return (
      <div className="main">
        <div className="logo-images-success-container">
          <div className="logo-last-page">
            <img
              src={require("../assets/HOT-logo.svg")}
              alt="logo"
              width="140"
              height="60"
            />
          </div>
          <div className="logo-last-page">
            <img
              src={require("../assets/classme-new-white-logo.svg")}
              alt="logo"
              width="100"
              height="40"
            />
            <p className="logo-text">ככה לומדים היום מהבית</p>
          </div>
        </div>

        {mainContent}
      </div>
    );
  }
}

export default Hot;
